var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoticeBoardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 1,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1622_2260",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1622_2260",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmCBQOLDoWYUYgAAAB7UlEQVRIx62VPUszURCFnwmrpLEUEbQXlQha2GttIWIhiiIIgoVY2AjpxcJim4iNSBpBCDYWQvwBNoKKEeuA0U4UTPwg91jk1Xz6JtnkVLs7c+fMPHcv1+T6+rCeHlrS46NZJlMzJL2+qmX9URzwoKsLbW9jiUSw7hcWYGXlPwaApdNml5dBystNTGB/x71yXPE4DA42VjqVMltaqpfllb9eXEAu15jB1dVPW+B5crOz1TnpdJmBWSwWBBOEw9jxcfX39/f2INLbG9bfXx5fXobd3TYgMsMks+fn8mazWajYg+CI/pZXL0Ha2Cj865W6uzNbXGzKQNrZQaOjhXEODsyOjmByErq74eysmBiJYNPTASZwrtSu+HxzY7a6+htxm5swPNy0gdnWVtOQ6yhUiUgumZRLJqW5uXYYNIgoEpH294uhSCSQQW1E5+fQ2wtjY8VEgJOTABNUy8z3wffbgkhaW4ORkcaWXl8XDmYpypoGzkHo32aPj8PQUGMG4TDEYlg+X1xfqlAI8nmkVEo6PAyKQJqZkSS58nMhxePS7a2H9vYw35fLZLDTU/j4aM7i6QleXrBEQi4axR4eYGoK5udhfR3JTC4alXK51i//H2WzhZpmv7epXEcHDAxgnZ1BcRUKfX7C/b2Fvr4AvgETkl9mbatq0wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wOC0yMFQxNDo0NDo1OCswMDowMGDaOisAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDgtMjBUMTQ6NDQ6NTgrMDA6MDARh4KXAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIyLTA4LTIwVDE0OjQ0OjU4KzAwOjAwRpKjSAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeBoardIcon);
export default __webpack_public_path__ + "static/media/notice-board-icon.a0e6120a2d2db117c576c4524213dba2.svg";
export { ForwardRef as ReactComponent };